import { h, FunctionComponent } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import styles from './frame.module.scss'
import Logo from './onfido.svg'
import { WhiteFrame } from './WhiteFrame'
import { classy } from '../helpers'
import { ProgressBars } from './ProgressBars'

interface Props {
  faceYaw: number
  ready: boolean
  setScanComplete: (arg0: boolean) => void
  scanComplete: boolean
  warningMessage: string
  instructionMessage: string
}

export const VideoFrame: FunctionComponent<Props> = ({
  faceYaw,
  ready,
  setScanComplete,
  scanComplete,
  warningMessage,
  instructionMessage,
}: Props) => {
  const [leftBar, setLeftBar] = useState(0)
  const [rightBar, setRightBar] = useState(0)

  useEffect(() => {
    if (leftBar === 100 && rightBar === 100) {
      setScanComplete(true)
    }
  }, [leftBar, rightBar, setScanComplete])

  const setBarValue = (
    side: string,
    faceYaw: number,
    mainSide: number,
    secondarySide: number,
    setMainSide: any,
    setSecondarySide: any
  ): void => {
    const minThreshold = 0.1
    const maxThreshold = 0.6
    const difference = 40
    const isLeft = side === 'left'
    if (mainSide < 100) setMainSide(0)
    if (secondarySide >= 100) setSecondarySide(100)
    else if (isLeft ? faceYaw > minThreshold : faceYaw < -minThreshold) {
      const newNumber = (faceYaw * (isLeft ? 100 : -100)) / maxThreshold
      if (Math.abs(secondarySide - newNumber) < difference)
        setSecondarySide(Math.round(newNumber))
    }
  }
  const checkFaceRotation = (): void => {
    if (faceYaw > 0)
      setBarValue('left', faceYaw, leftBar, rightBar, setLeftBar, setRightBar)
    else
      setBarValue('right', faceYaw, rightBar, leftBar, setRightBar, setLeftBar)
  }
  useEffect(() => {
    if (ready && !scanComplete) {
      checkFaceRotation()
    }
  }, [faceYaw])

  return (
    <div className={styles.videoGrid}>
      <div className={classy(styles.topBar, { [styles.absoluteTop]: ready })} />
      <div className={styles.middleBar}>
        {ready && (
          <div className={styles.progressBarsWrapper}>
            <div className={styles.frameOverlay}>
              <div className={styles.frameOverflow} />
              <svg
                width="512"
                height="600"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M512 0H0v600h512V0ZM255.5 108C198.891 108 153 153.891 153 210.5v91c0 56.609 45.891 102.5 102.5 102.5S358 358.109 358 301.5v-91c0-56.609-45.891-102.5-102.5-102.5Z"
                  fill="#1E1E24"
                />
              </svg>
              <div className={styles.frameOverflow} />
            </div>
            <ProgressBars left={leftBar} right={rightBar} />
          </div>
        )}

        {!ready && <WhiteFrame />}

        {!ready && warningMessage && (
          <div className={styles.warningPopup}>{warningMessage}</div>
        )}
      </div>
      <div
        className={classy(styles.bottomBar, { [styles.absoluteBottom]: ready })}
      >
        <span>{instructionMessage}</span>
        <Logo />
      </div>
    </div>
  )
}
